import { render, staticRenderFns } from "./onChainManage.vue?vue&type=template&id=4fb8b8f1&scoped=true&"
import script from "./onChainManage.vue?vue&type=script&lang=js&"
export * from "./onChainManage.vue?vue&type=script&lang=js&"
import style0 from "./onChainManage.vue?vue&type=style&index=0&id=4fb8b8f1&prod&lang=scss&scoped=true&"
import style1 from "./onChainManage.vue?vue&type=style&index=1&id=4fb8b8f1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb8b8f1",
  null
  
)

export default component.exports